// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import axios from "axios";
import { watchFun } from "@/utils/detectZoom.js";
watchFun();
window.addEventListener("resize", watchFun);
Vue.config.productionTip = false;
Vue.prototype.axios = axios;
Vue.use(ElementUI);
// import { baseUrl } from "@/utils/config";
// axios.defaults.baseURL = baseUrl;
axios.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("token");
    // && config.url !== "/auth/login"
    if (token && config.url !== "/auth/login") {
      config.headers.Authorization = "Bearer " + token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    // console.log(response)
    if (response.data.code === 401) {
      router.push({ name: "/" });
    }
    if (response.data) {
      return response.data;
    } else {
      return response;
    }
  },
  function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js